import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import {StorageService} from "../_services";
import {OverviewSessionsService} from "../_services/dashboard/overview";
import {Subject} from "rxjs";
import {
  DashboardFilter,
  DashboardSessionResultsAPIResponse,
  DashboardSessionsChartData
} from "../_models";
import {takeUntil} from "rxjs/operators";
import * as momentTz from "moment-timezone";

enum ResultChartLegend {
  Successful = 0,
  Bypass = 1,
  Dropoff = 2,
  Lifeline = 3,
  Error = 4
}

@Component({
  moduleId: module.id.toString(),
  templateUrl: 'session-results.component.html',
  styleUrls: ['./session-results.component.css'],
  selector: 'session-results',
  providers: [OverviewSessionsService],
})
export class SessionResultsComponent implements OnInit, OnChanges, OnDestroy {
  protected _destroy$: Subject<boolean> = new Subject<boolean>();
  public sessionsChartData: DashboardSessionsChartData = {
    chartLegend: false,
    labels: ["Successful", "Bypass", "Dropoffs", "Lifeline"],
    dataset: {
      backgroundColor: [
        "#163549",
        "#33bcd7",
        "#ffcc3e",
        "#e2e7ef",
        "#15c771",
        "#cc0000",
      ],
      hoverBorderColor: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],
      borderWidth: 3,
      data: [],
    },
    self_service_rate: [0, 0],
  };
  public loading: boolean = false;
  @Input('selectedFilters') selectedFilters: DashboardFilter = null;
  @Output('updateSessionChartData') updateSessionChartData: EventEmitter<any> = new EventEmitter<any>();
  chartOptions: any = {
    cutoutPercentage: 85,
    legend: {
      display: true,
      position: 'top',
      labels: {
        fontColor: "#2e3451",
        usePointStyle: true,
        fontSize: 13
      }
    },
    tooltips: {
      backgroundColor: 'rgba(47, 49, 66, 0.8)',
      titleFontSize: 13,
      titleFontColor: '#fff',
      caretSize: 0,
      cornerRadius: 4,
      xPadding: 10,
      displayColors: true,
      yPadding: 10
    }
  };

  constructor(protected sessionService: OverviewSessionsService,
              protected storageService: StorageService) {
  }

  ngOnInit() {
    this.sessionService.data$
      .pipe(takeUntil(this._destroy$))
      .subscribe((data: DashboardSessionResultsAPIResponse) => {
        this.loading = false;
        if (data && data.session_results) {
          const result: number[] = [];
          this.sessionsChartData.labels.forEach((label) => {
            if (label in data.session_results) {
              result.push(data.session_results[label]);
            } else {
              result.push(0);
            }
          });
          this.sessionsChartData = {
            ...this.sessionsChartData,
            dataset: {
              ...this.sessionsChartData.dataset,
              data: result,
            },
            self_service_rate: data.self_service_rate,
          };
          this.updateSessionChartData.emit(this.sessionsChartData);
        }
      });
  }

  ngOnChanges() {
    if (this.selectedFilters) {
      this.loading = true;
      this.sessionService.setFilter(this.buildFilter());
      this.sessionService.getData();
    }
  }

  protected buildFilter(): DashboardFilter {
    let timezone = this.storageService.get('timezone');
    if (!timezone) {
      timezone = momentTz.tz.guess();
    }
    return {
      ...this.selectedFilters,
      timezone: timezone,
    };
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  getPieDataPercent(data: number[], index: number) {
    let total = 0;

    data.forEach((value: number) => total += value);

    return total ? Math.round(100 * data[index] / total) : 0;
  }

  get getSuccessfulSessionRate() {
    let rate = 0;
    if (this.sessionsChartData.dataset && this.sessionsChartData.dataset.data) {
      rate = this.getPieDataPercent(this.sessionsChartData.dataset.data, ResultChartLegend.Successful);
    }
    return rate;
  }
}
